import { TemperatureType, TemperatureWithId } from '@hero/schema';

export const temperatureList: TemperatureWithId[] = [
  // Chilled (hottest to coldest)
  {
    id: 13,
    types: ['chilled'],
    degree: {
      min: 24,
      max: 27,
    },
  },
  {
    id: 12,
    types: ['chilled'],
    degree: {
      min: 20,
      max: 23,
    },
  },
  {
    id: 11,
    types: ['chilled'],
    degree: {
      min: 16,
      max: 19,
    },
  },
  {
    id: 10,
    types: ['chilled'],
    degree: {
      min: 12,
      max: 15,
    },
  },
  {
    id: 9,
    types: ['chilled'],
    degree: {
      min: 8,
      max: 11,
    },
  },
  {
    id: 8,
    types: ['chilled'],
    degree: {
      min: 4,
      max: 7,
    },
  },
  {
    id: 6,
    types: ['chilled'],
    degree: {
      min: 1,
      max: 3,
    },
  },
  // Frozen (hottest to coldest)
  {
    id: 5,
    types: ['frozen'],
    degree: {
      min: -2,
      max: 0,
    },
  },
  {
    id: 4,
    types: ['frozen'],
    degree: {
      min: -6,
      max: -3,
    },
  },
  {
    id: 3,
    types: ['frozen'],
    degree: {
      min: -10,
      max: -7,
    },
  },
  {
    id: 2,
    types: ['frozen'],
    degree: {
      min: -14,
      max: -11,
    },
  },
  {
    id: 1,
    types: ['frozen'],
    degree: {
      min: -18,
      max: -15,
    },
  },
] as const;

export const temperatureTypesList: TemperatureType[] = ['dry', 'chilled', 'frozen', 'hot'];
